import BaseApi from "../baseApi";
import { USER } from "../apiConstant";

class UserChatApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_BASE_API_URL;
    this.$axiosInstance = this.initAxiosInstance();
  }

  getSubscribeStatus() {
    return this.get(`${USER}/subscribe-status`);
  }
}

export default UserChatApi;
